import { Component, Inject, OnInit } from "@angular/core";
import { TuiDialogContext } from "@taiga-ui/core";
import { POLYMORPHEUS_CONTEXT } from "@tinkoff/ng-polymorpheus";
import { ApiService } from "src/app/core/services/shared/api.service";
import { CheckLoginSessionService } from "src/app/core/services/shared/check-login-session.service";
import { GlobalVarService } from "src/app/core/services/shared/global-var.service";
import { NotificationService } from "src/app/core/services/shared/notification.service";
import { CodehelpService } from "virtue-form";

@Component({
  selector: "app-mailme",
  templateUrl: "./mailme.component.html",
  styleUrls: ["./mailme.component.scss"],
})
export class MailmeComponent implements OnInit {
  a: any;
  mail: string = "";
  error: string = "";
  headerText: string = "";
  btnSection: string = "";
  dialogProfileData: any;
  constructor(
    private apiService: ApiService,
    private checkUserLogin: CheckLoginSessionService,
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<string>,
    private globalvar: GlobalVarService,
    private notificatioService: NotificationService,
    private codehelp: CodehelpService
  ) {
    const dialog = document.querySelector("tui-dialog");
    dialog.classList.add("mail-me");
  }

  ngOnInit(): void {
    let userInfoObj = this.codehelp.getUserProfile();

    if (userInfoObj != undefined) {
      let userInfo = JSON.parse(userInfoObj);
      if (userInfo && userInfo?.email) {
        this.mail = userInfo?.email;

        let headerText = this.context.data;

        if (headerText == "saveChanges") {
          this.btnSection = headerText;
          this.headerText = "Do you want to save changes?";
        }
        if (headerText == "mailMe") {
          this.btnSection = headerText;
          this.headerText = "Please confirm your e-mail ID";
        }
        // const [name,domain]= userInfo?.email.split('@');
        // const email = `${name[0]}${new Array(name.length).join('*')}@${domain}`;
        // this.mail = email
      }
      // this.mail = userInfo?.email;
    }
  }

  exit() {
    this.close();
    this.checkUserLogin.onLogout("Manual");
  }

  handleEmail(arg: any) {
    if (arg.target.value == "") {
      this.error = "Email ID is required";
    }
    if (arg.target.value) {
      const res = arg.target.value.match(
        "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$"
      );
      const a = res?.toString();
      if (res === null) {
        this.error = "Please enter valid email format";
      }
      if (arg.target.value == a) {
        this.error = "";
      }
      if (arg.target.value != a) {
        this.error = "Please enter valid  email format";
      }
    }
  }

  close() {
    this.context.completeWith("");
  }

  submit(data) {
    if (data.valid) {
      this.context.completeWith(this.mail);
    }
  }
}
